<template>
    <div class="formEditor">
      <h3 class="tit">{{ t('Profile.EditSenha.Title') }}</h3>

      <Form class="p-4 leading-[22px]" ref="form">
        <h6 class="text-15 pb-[6px]">{{ t('Profile.EditSenha.OriginalPassword') }}</h6>
        <PasswordInput v-model="oldPassword" :placeholder="t('Profile.EditSenha.OriginalPasswordPlaceholder')" icon-position="right" name="oldPassword" />

        <h6 class="text-15 pb-[6px] mt-4">{{ t('Profile.EditSenha.NewPassword') }}</h6>
        <PasswordInput v-model="newPassword" :placeholder="t('Profile.EditSenha.NewPasswordPlaceholder')" icon-position="right" name="newPassword" />

        <h6 class="text-15 pb-[6px] mt-4">{{ t('Profile.EditSenha.ConfirmPassword') }}</h6>
        <ConfirmPasswordInput ref="confirmPwRef" v-model="confirmPassword" :password="newPassword" :placeholder="t('Profile.EditSenha.ConfirmPasswordPlaceholder')" icon-position="right" />

        <div class="flex w-full gap-4 mt-6 text-white/75">
          <van-button @click="close" class="primaryBtn_transparent flex-1">{{ t('Common.Cancel') }}</van-button>
          <van-button @click="confirm" class="primaryBtn flex-1">{{ t('Common.Confirm') }}</van-button>
        </div>
      </Form>
    </div>
</template>

<script setup lang="ts">
  import Form from 'vant/lib/form';
  import PasswordInput from '@a/components/FormInput/passwordInput.vue';
  import ConfirmPasswordInput from '@a/components/FormInput/confirmPasswordInput.vue';
  import debounce from 'lodash-es/debounce'
  import { resetPw } from '@/api'
  import { encryptPassword } from '@/utils'
  import i18n from "@/i18n";
  const t = i18n.global.t;

  const {close} = defineProps<{
    close: () => void
  }>()

  const oldPassword = ref('');
  const newPassword = ref('');
  const confirmPassword = ref('');

  const validateMap = ref({
    oldPassword: 0,
    newPassword: 0,
    confirmPassword: 0,
  })

  provide('validateMap', validateMap)

  const canSubmit = computed(() => Object.values(validateMap.value).every(item => item === 1))
  
  const form = useTemplateRef('form')
  watch(newPassword, () => {
    if (confirmPassword.value) {
      // @ts-ignore
      form.value!.validate(['confirmPassword']).catch(e => {})
    }
  })

  const confirm = debounce(async () => {
    if (!canSubmit.value) return

    showLoadingToast({
      message: t('Common.Loading'),
      zIndex: 2999,
    })
    const res = await resetPw({ 
      originalPassword: encryptPassword(oldPassword.value), 
      newPassword: encryptPassword(newPassword.value)
    })
    if (res.code === 1) close()
  }, 300)
</script>

<style lang="scss" scoped>
.formEditor{
  --input-focus-bg-color: #FFFFFF2A;
  --van-cell-background: #FFFFFF1A;
  --input-tip-bg-color: #FFFFFF1A;

  color: #FFFFFFBF;

  .tit{
    @apply text-[15px] font-[600] h-[44px] bg-[var(--theme-gray-green40)] text-white text-center leading-[44px];
  }
}
</style>
